export default require('./src/main.js')




/** WEBPACK FOOTER **
 ** ./index.js
 **/